var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('masonry',{attrs:{"cols":_vm.$vuetify.breakpoint.lgAndDown ? 2 : 3,"gutter":15}},_vm._l((_vm.items),function(item){return _c('moments-card',{key:item.id,attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }